(function () {
  'use strict';

  var start = Date.parse('2026-11-02T00:00:00+01:00');
  var mainEnd = Date.parse('2026-12-01T00:00:00+01:00');
  var finalEnd = Date.parse('2026-12-08T00:00:00+01:00');
  var timers = document.querySelectorAll('[data-bf-countdown]');
  var periods = document.querySelectorAll('[data-bf-period]');
  var eyebrows = document.querySelectorAll('.hero-section .eyebrow-bts');
  var initialPeriods = Array.prototype.map.call(periods, function (node) { return node.textContent; });
  var initialEyebrows = Array.prototype.map.call(eyebrows, function (node) { return node.textContent; });
  var previousPhase;

  // Period copy changes only at campaign boundaries. Main-campaign copy never
  // announces a future extension; December copy appears only while it is active.
  function updatePeriod(phase) {
    if (phase === previousPhase) return;
    previousPhase = phase;
    var extension = {
      long: 'Podaljšani Black Friday velja do vključno 7. decembra 2026.',
      short: 'Podaljšano do 7. decembra 2026',
      range: '1.–7. december 2026'
    };
    periods.forEach(function (node, index) {
      var kind = node.getAttribute('data-bf-period');
      node.textContent = phase === 'ended' ? 'Black Friday akcija je zaključena.' :
        phase === 'extension' ? (extension[kind] || initialPeriods[index]) : initialPeriods[index];
    });
    eyebrows.forEach(function (node, index) {
      node.textContent = phase === 'ended' ? 'BLACK FRIDAY 2026 · AKCIJA JE ZAKLJUČENA' :
        phase === 'extension' ? 'PODALJŠANI BLACK FRIDAY' : initialEyebrows[index];
    });
  }

  function update() {
    var now = Date.now();
    var phase = now < start ? 'before' : now < mainEnd ? 'main' : now < finalEnd ? 'extension' : 'ended';
    var finished = phase === 'ended';
    var end = phase === 'before' ? start : phase === 'main' ? mainEnd : finalEnd;
    var label = finished ? 'AKCIJA JE ZAKLJUČENA' : phase === 'before' ? 'DO ZAČETKA' : phase === 'extension' ? 'PODALJŠANO · ŠE' : 'AKCIJA TRAJA ŠE';
    var remaining = finished ? 0 : Math.max(0, Math.ceil((end - now) / 1000));
    var days = Math.floor(remaining / 86400);
    var hours = Math.floor(remaining % 86400 / 3600);
    var minutes = Math.floor(remaining % 3600 / 60);
    var seconds = remaining % 60;
    var parts = [days, hours, minutes, seconds].map(function (value) {
      return String(value).padStart(2, '0');
    });
    updatePeriod(phase);
    timers.forEach(function (timer) {
      var values = timer.querySelector('.bf-countdown-values');
      timer.querySelector('[data-bf-countdown-label]').textContent = label;
      ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit, index) {
        timer.querySelector('[data-' + unit + ']').textContent = parts[index];
      });
      values.hidden = finished;
      values.setAttribute('aria-hidden', 'true');
      timer.setAttribute('aria-label', finished ? label : label + ': ' + days + ' dni, ' + hours + ' ur, ' + minutes + ' minut, ' + seconds + ' sekund');
    });
  }

  update();
  window.setInterval(update, 1000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) update();
  });
}());
